import { useState } from 'react';

// ----------------------------------------------------------------------

export default function useTabs(defaultValues, callback = null) {
  const [currentTab, setCurrentTab] = useState(defaultValues || '');

  return {
    currentTab,
    onChangeTab: (event, newValue) => {
      if (callback) {
        callback(newValue);
      }
      setCurrentTab(newValue);
    },
    setCurrentTab,
  };
}
